/**
 * Whether this device's kiosk exit is PIN-protected. The server stores only a
 * scrypt hash (`kioskExitPinHash`) in `device.settings`; verification happens
 * server-side via POST /device/verify-exit-pin. Shared by web, mobile, and tv
 * so every kiosk surface gates exit identically.
 */
export function deviceRequiresExitPin(settings: unknown): boolean {
  return Boolean(
    (settings as { kioskExitPinHash?: string } | undefined)?.kioskExitPinHash,
  );
}
